import { Formik } from "formik";
import { FC, createContext } from "react";
import TableLog from "./components/TableLog";

export interface LogPageContextProps {}

interface IProps {}

const initialContext = {};

export const LogPageContext =
  createContext<LogPageContextProps>(initialContext);

export const OrganizationPage: FC<IProps> = (props) => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {}}>
      <LogPageContext.Provider value={{}}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1 ">
              <TableLog />
            </div>
          </div>
        </div>
      </LogPageContext.Provider>
    </Formik>
  );
};

export default OrganizationPage;
